import * as logging from "./logging"

import { getLevelJson } from "./leveljson";

export let currentLevelIndex = 0;

export const LEVEL_ID_MAP : {
    [key: string]: number
} = {
    "beta-1-tutorial": 0,
    "beta-2-cut-1": 1,
    "beta-3-cut-2": 2,
    "beta-4-spikes": 3,
    "beta-5-multi-e": 4,
    "beta-6-jump": 5,
    "beta-7-multi-m": 6,
    "beta-8-multi-h": 7,
    "beta-demo-lasers": 8,
    "beta-t-single-1": 9,
    "beta-t-single-2-h": 10,
    "beta-t-single-3": 11,
    "beta-t-elevator": 12,
    "beta-t-basement": 13,
    "beta-t-double-under": 14,
    "friend-1-vert": 15,
    "friend-2-basement-v2": 16,
    "friend-3-move-1": 17,
    "friend-4-vert-spike": 18,
    "friend-5-dia-multi": 19,
    "friend-6-drop": 20,
    "friend-7-laser-1": 21,
    "friend-8-laser-2": 22,
    "friend-9-laser-3": 23,
    "friend-10-laser-4": 24,
    "friend-11-laser-5": 25,
    "new-1-vert-ab": 26,
    "new-2-drop-ab": 27,
    "new-3-multi-m-ab": 28,
    "new-4-multi-h-ab": 29,
    "new-5-multi-e-ab": 30,
    "kong-1-opposing": 31,
    "kong-2-shield": 32,
    "kong-3-box": 33,
    "kong-4-switcheroo": 34,
    "kong-5-triangle": 35
}

export const LEVELS : string[] = [
    //tutorial
    "beta-1-tutorial",

    //single cuts
    "beta-3-cut-2",
    "friend-1-vert", //"new-1-vert-ab" is the "onscreen" condition version
    "beta-4-spikes",
    "beta-t-single-1",
    "beta-t-single-2-h",
    "friend-4-vert-spike",
    "friend-10-laser-4",
    "friend-11-laser-5",

    //multi cuts
    "friend-5-dia-multi",
    "friend-6-drop", //"new-2-drop-ab" is the "onscreen" condition version
    "beta-6-jump",
    "friend-9-laser-3",
    "beta-5-multi-e", //"new-5-multi-e" is the "onscreen" condition version
    "friend-3-move-1",

    //3 cuts
    "beta-7-multi-m", //"new-3-multi-m-ab" is the "onscreen" condition version
    "beta-t-double-under",
    "beta-8-multi-h", //"new-4-multi-h-ab" is the "onscreen" condition version

    // harder laser levels
    "friend-8-laser-2",
    "friend-7-laser-1",

    //challenge
    "kong-1-opposing",
    "kong-2-shield",
    "kong-3-box",
    "kong-4-switcheroo",
    "kong-5-triangle"
];

export function nextLevel(): string {
    currentLevelIndex = (currentLevelIndex + 1) % LEVELS.length;
    return LEVELS[currentLevelIndex];
}

export function isFinished(): boolean {
    // Go to victory after level 20 before challenge levels
    return currentLevelIndex === LEVELS.length - 1 || currentLevelIndex === 19;
}

export function challengesAvailable(): boolean {
    return currentLevelIndex >= 19;
}

export function challengesFinished(): boolean {
    return currentLevelIndex === LEVELS.length - 1;
}

export function syncToLevel(levelName: string) {
    currentLevelIndex = LEVELS.indexOf(levelName);
    if (currentLevelIndex === -1) {
        throw new Error(`Could not find level ${levelName}`);
    }
}



// WEBPACK FOOTER //
// ./src/progression.ts